const scrollToTop = () => {
    const element = document.getElementById('app-content-container');
    if (element) {
        element.scrollTo(0, 0);
    }
};

export default {
    scrollToTop,
};
